// Registre des articles du blog RenoHab (du plus récent au plus ancien).
//
// ➜ POUR AJOUTER UN ARTICLE : insérer une nouvelle entrée EN TÊTE de ce tableau.
//    Elle alimente automatiquement :
//      - la page /blog (liste complète),
//      - la section "Ressources & conseils" de l'accueil (6 derniers articles),
//      - les vignettes optimisées générées au build (scripts/make-blog-thumbs.mjs).
//    La route React (App.js) et public/sitemap.xml restent à ajouter séparément.
//
// Champs :
//   slug    : segment d'URL après /blog/ (doit correspondre à la route dans App.js)
//   title   : titre affiché sur la carte
//   excerpt : 1 à 2 phrases de résumé
//   tag     : thème court (ex. "Aides", "Chauffage", "Isolation")
//   date    : date de publication, format court FR (ex. "15 sept. 2026")
//   image   : chemin public de l'image (en général /blog/<slug>.jpg)
//   alt     : texte alternatif de l'image

export const ARTICLES = [
  {
    slug: "interdiction-location-classe-e-2034-bailleurs",
    title: "Logement classé E en 2026 : anticiper l'interdiction de louer en 2034",
    excerpt: "Au 1er janvier 2034, les logements classés E seront interdits à la location. DPE actualisé, travaux prioritaires, CEE, éco-PTZ et déficit foncier : le guide complet pour agir maintenant.",
    tag: "DPE",
    date: "3 nov. 2026",
    image: "/blog/interdiction-location-classe-e-2034-bailleurs.jpg",
    alt: "Propriétaire bailleur devant un logement classé E sur le DPE — calendrier d'interdiction de location 2034",
  },
  {
    slug: "triple-vitrage-double-vitrage-guide-2026",
    title: "Triple vitrage ou double vitrage : lequel choisir et financer en 2026 ?",
    excerpt: "Ug 0,5 vs 1,0 W/m²K, zones climatiques, prix posés et aides CEE 2026 : le guide complet pour choisir entre double et triple vitrage après la suppression de MaPrimeRénov' par geste.",
    tag: "Isolation",
    date: "2 nov. 2026",
    image: "/blog/triple-vitrage-double-vitrage-guide-2026.jpg",
    alt: "Fenêtre à triple vitrage installée dans une maison rénovée — isolation thermique performante",
  },
  {
    slug: "autoconsommation-solaire-pompe-a-chaleur-2026",
    title: "Panneaux solaires et pompe à chaleur : la combinaison gagnante pour l'autoconsommation en 2026",
    excerpt: "Associer des panneaux photovoltaïques à une pompe à chaleur air/eau permet de réduire sa facture d'énergie de 30 à 50 %. Guide pratique, aides disponibles et conseils de pilotage.",
    tag: "Chauffage",
    date: "1er nov. 2026",
    image: "/blog/autoconsommation-solaire-pompe-a-chaleur-2026.jpg",
    alt: "Maison avec panneaux solaires en toiture et pompe à chaleur extérieure",
  },
  {
    slug: "calculer-economies-renovation-energetique-2026",
    title: "Calculer ses économies d'énergie après rénovation : méthode et exemples concrets 2026",
    excerpt: "Combien va-t-on vraiment économiser sur sa facture d'énergie après une rénovation ? Méthode en 3 étapes, exemples chiffrés et retour sur investissement pour une maison F passant en classe B.",
    tag: "Conseils",
    date: "31 oct. 2026",
    image: "/blog/calculer-economies-renovation-energetique-2026.jpg",
    alt: "Maison rénovée avec étiquette DPE affichant une classe B, symbole d'économies d'énergie",
  },
  {
    slug: "tarif-tempo-edf-pompe-a-chaleur-hiver-2026",
    title: "Tarif Tempo EDF et pompe à chaleur : 5 stratégies pour passer l'hiver 2026-2027 sans facture salée",
    excerpt: "Avec 22 jours rouges dès novembre 2026, le tarif Tempo EDF peut faire exploser la facture d'une PAC mal pilotée. Découvrez 5 stratégies concrètes pour limiter la note cet hiver.",
    tag: "Chauffage",
    date: "30 oct. 2026",
    image: "/blog/tarif-tempo-edf-pompe-a-chaleur-hiver-2026.jpg",
    alt: "Unité extérieure de pompe à chaleur en hiver sous la neige avec givre",
  },
  {
    slug: "interdiction-location-classe-f-2028",
    title: "Interdiction de louer les logements classés F en 2028 : ce que doit faire le propriétaire bailleur",
    excerpt: "Au 1er janvier 2028, les logements classés F seront interdits à la location. Plus d'un million de bailleurs ont 15 mois pour rénover. Plan de travaux, aides et calendrier à respecter.",
    tag: "DPE",
    date: "29 oct. 2026",
    image: "/blog/interdiction-location-classe-f-2028.jpg",
    alt: "Logement classé F sur le DPE : propriétaire bailleur face à l'obligation de rénover avant 2028",
  },
  {
    slug: "deficit-foncier-renovation-energetique-2026",
    title: "Déficit foncier et rénovation énergétique 2026 : plafond doublé à 21 400 €",
    excerpt: "Propriétaires bailleurs : déduisez jusqu'à 21 400 €/an de votre revenu global en faisant sortir votre logement du statut de passoire thermique. Conditions, calcul et démarches.",
    tag: "Fiscalité",
    date: "28 oct. 2026",
    image: "/blog/deficit-foncier-renovation-energetique-2026.jpg",
    alt: "Propriétaire bailleur calculant les avantages fiscaux du déficit foncier pour sa rénovation énergétique",
  },
  {
    slug: "arnaques-renovation-energetique-comment-se-proteger-2026",
    title: "Arnaques en rénovation énergétique : comment les reconnaître et se protéger en 2026",
    excerpt: "52 000 signalements en 2025, des ménages endettés de dizaines de milliers d'euros : les escroqueries explosent. Apprenez à repérer les signaux d'alerte et à vous protéger.",
    tag: "Conseils",
    date: "27 oct. 2026",
    image: "/blog/arnaques-renovation-energetique-comment-se-proteger-2026.jpg",
    alt: "Particulier qui examine attentivement un devis de rénovation énergétique pour détecter une arnaque",
  },
  {
    slug: "leasing-social-pompe-a-chaleur-2026",
    title: "Leasing social pompe à chaleur 2026 : conditions, reste à charge et démarches",
    excerpt: "Ouvert depuis le 1er octobre 2026, ce dispositif permet aux ménages modestes d'installer une PAC avec un reste à charge de 1 000 à 1 500 € seulement. Éligibilité, fonctionnement et étapes.",
    tag: "Aides",
    date: "26 oct. 2026",
    image: "/blog/leasing-social-pompe-a-chaleur-2026.jpg",
    alt: "Unité extérieure de pompe à chaleur installée sur une maison individuelle — leasing social PAC 2026",
  },
  {
    slug: "label-rge-artisan-reforme-2026",
    title: "Label RGE 2026 : réforme, comment vérifier un artisan et éviter les arnaques",
    excerpt: "L'arrêté du 23 juin 2026 renforce les contrôles et les sanctions du label RGE. Sans artisan certifié RGE dans la bonne spécialité, aucune aide n'est accessible. Guide pratique pour vérifier et comprendre ce qui change.",
    tag: "Artisans",
    date: "25 oct. 2026",
    image: "/blog/label-rge-artisan-reforme-2026.jpg",
    alt: "Artisan certifié RGE sur un chantier de rénovation énergétique — qualification Reconnu Garant de l'Environnement",
  },
  {
    slug: "isolation-biosourcee-ouate-chanvre-liege-2026",
    title: "Isolation biosourcée en 2026 : ouate de cellulose, laine de chanvre et liège — guide et aides",
    excerpt: "Ouate de cellulose, laine de chanvre, liège : performances, prix au m² et aides disponibles (CEE, TVA 5,5 %, éco-PTZ) pour ces isolants écologiques en 2026.",
    tag: "Isolation",
    date: "24 oct. 2026",
    image: "/blog/isolation-biosourcee-ouate-chanvre-liege-2026.jpg",
    alt: "Matériaux d'isolation biosourcés : ouate de cellulose, laine de chanvre et liège pour la rénovation énergétique",
  },
  {
    slug: "pac-maprimerenov-fin-janvier-2027",
    title: "Pompe à chaleur et MaPrimeRénov' : pourquoi agir avant le 1er janvier 2027",
    excerpt: "Le PLF 2027 prévoit de retirer les PAC de MaPrimeRénov' par geste. Jusqu'à 5 000 € d'aide en jeu : montants actuels, alternatives CEE et démarches pour sécuriser votre dossier avant la fin d'année.",
    tag: "Aides",
    date: "23 oct. 2026",
    image: "/blog/pac-maprimerenov-fin-janvier-2027.jpg",
    alt: "Unité extérieure de pompe à chaleur installée en façade d'une maison individuelle",
  },
  {
    slug: "declaration-prealable-travaux-renovation-energetique-2026",
    title: "Déclaration préalable et permis de construire pour la rénovation énergétique en 2026",
    excerpt: "PAC, ITE, fenêtres, solaire : quel type d'autorisation faut-il en mairie avant vos travaux ? Le guide complet avec le nouveau décret PAC de mars 2026 qui supprime la DP.",
    tag: "Démarches",
    date: "22 oct. 2026",
    image: "/blog/declaration-prealable-travaux-renovation-energetique-2026.jpg",
    alt: "Maison individuelle en cours de rénovation énergétique — démarches administratives en mairie",
  },
  {
    slug: "plan-pluriannuel-travaux-copropriete-2026",
    title: "Plan Pluriannuel de Travaux (PPT) en copropriété : obligations, étapes et aides 2026",
    excerpt: "Depuis 2025, toutes les copropriétés de plus de 15 ans doivent se doter d'un PPT. Découvrez ce qu'il contient, comment le faire élaborer et quelles aides mobiliser pour financer les travaux.",
    tag: "Copropriété",
    date: "21 oct. 2026",
    image: "/blog/plan-pluriannuel-travaux-copropriete-2026.jpg",
    alt: "Immeuble en copropriété avec travaux de rénovation énergétique en cours",
  },
  {
    slug: "pompe-a-chaleur-haute-temperature-radiateurs-2026",
    title: "PAC haute température : remplacer sa chaudière sans changer ses radiateurs",
    excerpt: "Vos radiateurs en fonte sont prévus pour 70–80 °C ? La PAC haute température s'y adapte parfaitement, sans remplacer le réseau existant. Prix, aides CEE et MaPrimeRénov' en 2026.",
    tag: "Chauffage",
    date: "20 oct. 2026",
    image: "/blog/pompe-a-chaleur-haute-temperature-radiateurs-2026.jpg",
    alt: "Unité extérieure de pompe à chaleur haute température installée sur une maison avec radiateurs anciens",
  },
  {
    slug: "maprimerenov-delais-dossier-2026",
    title: "MaPrimeRénov' 2026 : délais jusqu'à 6 mois — comment préparer un dossier solide",
    excerpt: "83 000 dossiers en attente, guichet rouvert le 23 février : les délais d'instruction dépassent 6 mois. Guide pratique pour constituer un dossier complet et éviter les blocages.",
    tag: "Aides",
    date: "19 oct. 2026",
    image: "/blog/maprimerenov-delais-dossier-2026.jpg",
    alt: "Propriétaire remplissant un dossier de demande MaPrimeRénov' sur ordinateur",
  },
  {
    slug: "garantie-decennale-renovation-energetique-2026",
    title: "Garantie décennale et rénovation énergétique : les 3 protections légales en 2026",
    excerpt: "Garantie de parfait achèvement, biennale ou décennale : quels travaux de rénovation énergétique sont couverts et comment vérifier l'assurance de votre artisan avant de signer.",
    tag: "Travaux",
    date: "18 oct. 2026",
    image: "/blog/garantie-decennale-renovation-energetique-2026.jpg",
    alt: "Artisan présentant une attestation d'assurance décennale pour des travaux de rénovation énergétique",
  },
  {
    slug: "dpe-coefficient-electrique-2027-reclassement",
    title: "Coefficient électrique DPE 2027 : 300 000 logements changent de classe au 1er janvier",
    excerpt: "Au 1er janvier 2027, le coefficient de conversion de l'électricité passe de 1,9 à 1,7. Environ 300 000 logements pourraient changer de classe sans travaux — dont des passoires thermiques.",
    tag: "DPE",
    date: "17 oct. 2026",
    image: "/blog/dpe-coefficient-electrique-2027-reclassement.jpg",
    alt: "Étiquette DPE — réforme du coefficient électrique 2027, logements qui changent de classe",
  },
  {
    slug: "mention-france-renov-obligatoire-devis-2026",
    title: "Mention France Rénov' obligatoire sur vos devis : votre protection anti-arnaques depuis octobre 2026",
    excerpt: "Depuis le 1er octobre 2026, tout artisan doit afficher la mention France Rénov' sur ses publicités et devis. Ce que ça change pour vous, les sanctions encourues et comment en faire un critère de choix.",
    tag: "Aides",
    date: "16 oct. 2026",
    image: "/blog/mention-france-renov-obligatoire-devis-2026.jpg",
    alt: "Particulier examinant un devis de rénovation énergétique avec la mention France Rénov'",
  },
  {
    slug: "ite-ou-iti-isolation-murs-comment-choisir-2026",
    title: "ITE ou ITI : comment choisir l'isolation de vos murs en 2026 ?",
    excerpt: "Extérieure ou intérieure ? Comparatif complet des deux techniques, des coûts réels et des aides disponibles (CEE, éco-PTZ, TVA 5,5 %) après la suppression de MaPrimeRénov' par geste.",
    tag: "Isolation",
    date: "15 oct. 2026",
    image: "/blog/ite-ou-iti-isolation-murs-comment-choisir-2026.jpg",
    alt: "Chantier d'isolation de façade extérieure — ITE ou ITI, comment choisir en 2026",
  },
  {
    slug: "vmc-hygroreglable-type-a-b-aides-2026",
    title: "VMC hygroréglable type A et B : fonctionnement, prix et aides CEE en 2026",
    excerpt: "Type A ou type B ? Comprendre les différences, les prix posés (1 000 à 3 500 €) et la prime CEE (fiche BAR-TH-127) pour financer votre VMC hygroréglable.",
    tag: "Ventilation",
    date: "14 oct. 2026",
    image: "/ventilation.webp",
    alt: "VMC hygroréglable installée dans une salle de bain — ventilation adaptée à l'humidité",
  },
  {
    slug: "budget-anah-2027-maprimerenov-baisse",
    title: "Budget 2027 : l'Anah perd 200 M€ — ce qui change pour MaPrimeRénov'",
    excerpt: "Le PLF 2027 réduit la dotation de l'Anah de 200 millions d'euros. Les gestes isolés basculent vers les CEE, la rénovation d'ampleur reste prioritaire. Dossiers existants : aucun risque.",
    tag: "Aides",
    date: "11 oct. 2026",
    image: "/DALL-E-2-maison.webp",
    alt: "Maison individuelle rénovée avec panneau solaire — budget MaPrimeRénov' 2027",
  },
  {
    slug: "ponts-thermiques-detection-solutions-2026",
    title: "Ponts thermiques 2026 : comment les détecter et les traiter pour réduire vos factures",
    excerpt: "Les ponts thermiques représentent jusqu'à 30 % des déperditions de chaleur. Découvrez comment les repérer (thermographie, signes visuels) et quelles solutions existent en rénovation.",
    tag: "Isolation",
    date: "10 oct. 2026",
    image: "/blog/ponts-thermiques-detection-solutions-2026.jpg",
    alt: "Thermographie infrarouge d'une maison révélant des ponts thermiques",
  },
  {
    slug: "chauffe-eau-thermodynamique-vs-solaire-2026",
    title: "Chauffe-eau thermodynamique ou solaire : lequel choisir en 2026 ?",
    excerpt: "CET ou CESI ? Comparatif complet des deux technologies, des prix d'installation, des aides MaPrimeRénov' et CEE, et des critères pour faire le bon choix selon votre logement.",
    tag: "Eau chaude",
    date: "9 oct. 2026",
    image: "/blog/chauffe-eau-thermodynamique-vs-solaire-2026.jpg",
    alt: "Chauffe-eau thermodynamique installé dans une buanderie moderne",
  },
  {
    slug: "radiateurs-inertie-aides-2026",
    title: "Radiateurs à inertie 2026 : prime CEE, TVA 5,5 % et guide pour bien choisir",
    excerpt: "Remplacer vos vieux convecteurs : prime CEE (fiche BAR-TH-158) de 50 à 300 € par appareil, TVA à 5,5 %, conditions d'éligibilité et conseils pour choisir inertie sèche, fluide ou double cœur de chauffe.",
    tag: "Chauffage",
    date: "8 oct. 2026",
    image: "/blog/radiateurs-inertie-aides-2026.jpg",
    alt: "Radiateur à inertie électrique dans un salon — aides CEE 2026",
  },
  {
    slug: "maprimerenov-par-geste-apres-septembre-2026",
    title: "MaPrimeRénov' par geste après le 1er septembre 2026 : les 3 aides encore disponibles",
    excerpt: "Depuis le 1er septembre 2026, seuls 3 gestes restent éligibles à MaPrimeRénov' par geste : PAC, réseau de chaleur et audit énergétique couplé. Montants, conditions et démarches.",
    tag: "Aides",
    date: "28 sept. 2026",
    image: "/blog/maprimerenov-par-geste-apres-septembre-2026.jpg",
    alt: "Pompe à chaleur installée devant une maison rénovée — MaPrimeRénov' par geste après septembre 2026",
  },
  {
    slug: "raccordement-reseau-chaleur-urbain-2026",
    title: "Réseau de chaleur urbain en 2026 : raccordement, aides et démarches",
    excerpt: "Le raccordement au réseau de chaleur reste l'un des 4 gestes éligibles à MaPrimeRénov' après septembre 2026. Jusqu'à 1 200 € d'aide, CEE cumulables, TVA 5,5 % et impact réel sur le DPE.",
    tag: "Chauffage",
    date: "27 sept. 2026",
    image: "/blog/raccordement-reseau-chaleur-urbain-2026.jpg",
    alt: "Réseau de chaleur urbain — chaufferie collective et réseau de distribution souterrain",
  },
  {
    slug: "pompe-a-chaleur-hybride-gaz-2026",
    title: "Pompe à chaleur hybride gaz : quelles aides après septembre 2026 ?",
    excerpt: "La PAC hybride reste éligible à MaPrimeRénov' par geste, mais est exclue du parcours d'ampleur depuis septembre 2026. Ce qui change et les alternatives.",
    tag: "Chauffage",
    date: "26 sept. 2026",
    image: "/blog/pompe-a-chaleur-hybride-gaz-2026.jpg",
    alt: "Unité extérieure d'une pompe à chaleur hybride installée sur une maison individuelle",
  },
  {
    slug: "chaudiere-gaz-2026-remplacement-cout",
    title: "Chaudière à gaz en 2026 : encore légale mais sans aide — ce que ça coûte vraiment",
    excerpt: "Remplacer une chaudière à gaz reste autorisé, mais sans MaPrimeRénov', CEE ni TVA réduite. Le vrai coût, et les alternatives subventionnées.",
    tag: "Chauffage",
    date: "23 sept. 2026",
    image: "/blog/chaudiere-gaz-2026-remplacement-cout.jpg",
    alt: "Chaudière à gaz murale dans un logement en cours de rénovation",
  },
  {
    slug: "isolation-toiture-terrasse-2026",
    title: "Isolation de la toiture-terrasse en 2026 : techniques, aides et retour sur investissement",
    excerpt: "Toiture-terrasse inaccessible, accessible ou végétalisée : les techniques adaptées, les aides 2026 (MaPrimeRénov', CEE, TVA 5,5 %) et le financement.",
    tag: "Isolation",
    date: "20 sept. 2026",
    image: "/blog/isolation-toiture-terrasse-2026.jpg",
    alt: "Toiture-terrasse d'une maison moderne avec isolation thermique",
  },
  {
    slug: "plancher-chauffant-pac-basse-temperature-2026",
    title: "Plancher chauffant + PAC : le duo gagnant pour réduire vos factures en 2026",
    excerpt: "Associer une pompe à chaleur à un plancher chauffant basse température maximise le confort et le rendement. Fonctionnement, coûts et aides disponibles.",
    tag: "Chauffage",
    date: "15 sept. 2026",
    image: "/blog/plancher-chauffant-pac-basse-temperature-2026.jpg",
    alt: "Plancher chauffant basse température et pompe à chaleur dans une maison rénovée",
  },
  {
    slug: "renovation-energetique-residence-secondaire-2026",
    title: "Résidence secondaire : quelles aides à la rénovation énergétique en 2026 ?",
    excerpt: "MaPrimeRénov' est réservée aux résidences principales, mais CEE, éco-PTZ et TVA 5,5 % restent accessibles. Le point sur ce qui finance une maison de vacances.",
    tag: "Aides",
    date: "13 sept. 2026",
    image: "/blog/renovation-energetique-residence-secondaire-2026.jpg",
    alt: "Maison de vacances en France bénéficiant d'une rénovation énergétique",
  },
  {
    slug: "maprimerenov-2027-maisons-dpe-fg-ce-qui-change",
    title: "Maisons F ou G : l'échéance MaPrimeRénov' reportée au 1er janvier 2028",
    excerpt: "Le décret du 25 août 2026 laisse aux maisons F et G l'accès aux aides par geste jusqu'au 31 décembre 2027 (DPE exigé en 2028). Ce que ça change, et pourquoi agir maintenant.",
    tag: "Aides",
    date: "12 sept. 2026",
    image: "/blog/maprimerenov-2027-maisons-dpe-fg-ce-qui-change.jpg",
    alt: "Étiquette DPE F ou G sur une maison ancienne – réforme MaPrimeRénov' 2027",
  },
  {
    slug: "agrement-pac-prime-cee-bonifiee-septembre-2026",
    title: "Prime CEE PAC : l'agrément obligatoire depuis le 1er septembre 2026",
    excerpt: "Depuis le 1er septembre, seules les PAC agréées donnent accès à la prime CEE bonifiée. Vérifiez votre modèle sur la liste ADEME avant de signer.",
    tag: "Aides",
    date: "11 sept. 2026",
    image: "/blog/agrement-pac-prime-cee-bonifiee-septembre-2026.jpg",
    alt: "Agrément PAC prime CEE bonifiée : pompe à chaleur agréée ADEME depuis septembre 2026",
  },
  {
    slug: "entretien-pompe-a-chaleur-pac-2026",
    title: "Entretien PAC 2026 : obligations, fréquence et prix",
    excerpt: "À quelle fréquence faire entretenir sa pompe à chaleur ? Quelles obligations F-Gaz ? Combien ça coûte ? Tout ce que vous devez savoir avant l'hiver.",
    tag: "Maintenance",
    date: "10 sept. 2026",
    image: "/blog/entretien-pompe-a-chaleur-pac-2026.jpg",
    alt: "Entretien pompe à chaleur : technicien en maintenance PAC extérieure",
  },
  {
    slug: "pret-avance-renovation-par-2026",
    title: "PAR et PAR+ 2026 : rénover sans avancer l'argent",
    excerpt: "0 % d'intérêt pendant 10 ans pour les ménages modestes, pas de mensualités pendant toute la détention du bien : le Prêt Avance Rénovation est une alternative méconnue à l'Éco-PTZ.",
    tag: "Financement",
    date: "9 sept. 2026",
    image: "/blog/pret-avance-renovation-par-2026.jpg",
    alt: "Prêt Avance Rénovation PAR et PAR+ : financer sans avance de fonds",
  },
  {
    slug: "thermostat-programmable-regulation-chauffage-2026",
    title: "Thermostat programmable en 2026 : économies, obligation et aides disponibles",
    excerpt: "-7 % par degré économé, obligation légale reportée à 2030, CEE BAR-TH-173 encore actif : tout savoir sur la régulation du chauffage cette année.",
    tag: "Régulation",
    date: "8 sept. 2026",
    image: "/blog/thermostat-programmable-regulation-chauffage-2026.jpg",
    alt: "Thermostat programmable : économies, obligation et aides 2026",
  },
  {
    slug: "pompe-a-chaleur-air-air-reversible-aides-2026",
    title: "PAC air/air réversible : aides, prix et conditions en 2026",
    excerpt: "Prime CEE jusqu'à 975 €, TVA à 5,5 % depuis juillet 2026 : tout ce que vous devez savoir sur le split réversible avant de vous lancer.",
    tag: "Chauffage",
    date: "7 sept. 2026",
    image: "/blog/pompe-a-chaleur-air-air-reversible-aides-2026.jpg",
    alt: "Pompe à chaleur air/air réversible : aides 2026",
  },
  {
    slug: "chauffe-eau-solaire-individuel-cesi-2026",
    title: "CESI en 2026 : quelles aides après la réforme de septembre ?",
    excerpt: "MaPrimeRénov' par geste ne finance plus le chauffe-eau solaire depuis le 1er septembre 2026. CEE, TVA 5,5 %, Éco-PTZ : voici ce qui reste et si le CESI est encore rentable.",
    tag: "Eau chaude sanitaire",
    date: "6 sept. 2026",
    image: "/blog/chauffe-eau-solaire-individuel-cesi-2026.jpg",
    alt: "Chauffe-eau solaire individuel CESI : aides 2026",
  },
  {
    slug: "passoire-thermique-vendre-ou-renover-2026",
    title: "Passoire thermique : vendre ou rénover en 2026 ?",
    excerpt: "Logement F ou G : décote à la vente, interdiction de louer, aides jusqu'à 40 000 €… On compare les deux options chiffres à l'appui pour vous aider à choisir.",
    tag: "Stratégie patrimoine",
    date: "5 sept. 2026",
    image: "/blog/passoire-thermique-vendre-ou-renover-2026.jpg",
    alt: "Passoire thermique : faut-il vendre ou rénover en 2026 ?",
  },
  {
    slug: "renovation-appartement-copropriete-travaux-privatifs-2026",
    title: "Appartement en copropriété : quels travaux sans vote en AG ?",
    excerpt: "Isolation intérieure, chauffe-eau thermodynamique, VMC : ce que vous pouvez faire seul dans votre partie privative, les aides disponibles et ce qui nécessite un vote en assemblée générale.",
    tag: "Copropriété",
    date: "4 sept. 2026",
    image: "/blog/renovation-appartement-copropriete-travaux-privatifs-2026.jpg",
    alt: "Rénovation énergétique en appartement copropriété : travaux privatifs 2026",
  },
  {
    slug: "maprimerenov-proprietaire-bailleur-2026",
    title: "MaPrimeRénov' bailleur 2026 : toutes les aides pour votre logement locatif",
    excerpt: "Interdiction de louer les passoires G depuis janvier 2025, fin du monogeste en septembre 2026 : ce que chaque propriétaire bailleur doit savoir pour rénover et maintenir son bien en location.",
    tag: "Aides & financement",
    date: "3 sept. 2026",
    image: "/blog/maprimerenov-proprietaire-bailleur-2026.jpg",
    alt: "MaPrimeRénov' propriétaire bailleur 2026 : aides, conditions et démarches",
  },
  {
    slug: "pompe-a-chaleur-geothermique-sol-eau-2026",
    title: "PAC géothermique sol/eau : fonctionnement, prix et aides en 2026",
    excerpt: "La pompe à chaleur géothermique affiche un COP de 3,5 à 5, sans unité extérieure et sans dépendance aux températures hivernales. Prix, capteurs horizontaux vs sondes verticales, et aides disponibles.",
    tag: "Chauffage",
    date: "2 sept. 2026",
    image: "/blog/pompe-a-chaleur-geothermique-sol-eau-2026.jpg",
    alt: "Pompe à chaleur géothermique sol/eau : fonctionnement, prix et aides en 2026",
  },
  {
    slug: "dpe-collectif-copropriete-2026",
    title: "DPE collectif en copropriété : obligations 2026, coût et démarches",
    excerpt: "Obligatoire depuis janvier 2026 pour toutes les copropriétés, le DPE collectif conditionne l'accès aux aides : MaPrimeRénov' Copro, CEE, éco-PTZ. Qui est concerné, combien ça coûte, comment l'obtenir.",
    tag: "Copropriété",
    date: "1er sept. 2026",
    image: "/blog/dpe-collectif-copropriete-2026.jpg",
    alt: "DPE collectif en copropriété : obligations 2026, coût et démarches",
  },
  {
    slug: "preparer-logement-hiver-2026-checklist",
    title: "Préparer son logement pour l'hiver 2026 : la checklist complète",
    excerpt: "Entretien chaudière obligatoire, purge des radiateurs, VMC, joints de fenêtres, ramonage : la liste des gestes indispensables à réaliser avant novembre pour chauffer efficacement et sans mauvaise surprise.",
    tag: "Chauffage",
    date: "31 août 2026",
    image: "/blog/preparer-logement-hiver-2026-checklist.jpg",
    alt: "Préparer son logement pour l'hiver 2026 : checklist travaux et entretiens",
  },
  {
    slug: "isolation-combles-amenages-sarking-2026",
    title: "Combles aménagés : Sarking, prix et aides 2026",
    excerpt: "Isolation des rampants de toiture, technique Sarking par l'extérieur ou isolation par l'intérieur : tout savoir sur les solutions, les prix et les aides disponibles (MaPrimeRénov', CEE, TVA 5,5 %).",
    tag: "Isolation",
    date: "30 août 2026",
    image: "/blog/isolation-combles-amenages-sarking-2026.jpg",
    alt: "Isolation des combles aménagés par technique Sarking en 2026",
  },
  {
    slug: "choisir-artisan-rge-2026",
    title: "Artisan RGE 2026 : comment le trouver, le vérifier et éviter les arnaques",
    excerpt: "Sans artisan RGE, pas d'aide à la rénovation : ni MaPrimeRénov', ni CEE, ni Éco-PTZ. Comment identifier le bon professionnel, vérifier sa certification et ne pas tomber dans les pièges du démarchage abusif.",
    tag: "Démarches",
    date: "29 août 2026",
    image: "/blog/choisir-artisan-rge-2026.jpg",
    alt: "Artisan RGE : comment trouver et vérifier un professionnel certifié en 2026",
  },
  {
    slug: "attestation-dpe-ademe-2026-etiquette-gratuite",
    title: "Attestation DPE ADEME 2026 : nouvelle étiquette gratuite en 5 minutes",
    excerpt: "7 millions de logements gagnent une classe DPE depuis janvier 2026. Si votre diagnostic date de 2021 à 2025, téléchargez gratuitement votre attestation officielle sur l'Observatoire ADEME — sans diagnostiqueur.",
    tag: "DPE",
    date: "28 août 2026",
    image: "/blog/attestation-dpe-ademe-2026-etiquette-gratuite.jpg",
    alt: "Attestation DPE ADEME 2026 : nouvelle étiquette gratuite en ligne",
  },
  {
    slug: "rendez-vous-france-renov-maprimerenov-2026",
    title: "RDV France Rénov' obligatoire : l'étape clé avant MaPrimeRénov' rénovation d'ampleur",
    excerpt: "Depuis février 2026, un entretien gratuit avec un conseiller France Rénov' est exigé avant tout dépôt de dossier. Comment prendre RDV, quoi préparer et obtenir l'attestation indispensable.",
    tag: "Démarches",
    date: "27 août 2026",
    image: "/blog/rendez-vous-france-renov-maprimerenov-2026.jpg",
    alt: "Rendez-vous France Rénov' obligatoire MaPrimeRénov' 2026",
  },
  {
    slug: "cee-renovation-ampleur-classes-efg-septembre-2026",
    title: "CEE rénovation d'ampleur : seuls les logements E, F, G éligibles dès le 1er septembre",
    excerpt: "L'arrêté du 17 août 2026 exclut les logements classés D de la prime CEE rénovation d'ampleur. Ce qui change, la dérogation pour les dossiers déposés avant le 1er septembre, et les aides alternatives.",
    tag: "Prime CEE",
    date: "26 août 2026",
    image: "/blog/cee-renovation-ampleur-classes-efg-septembre-2026.jpg",
    alt: "CEE rénovation d'ampleur logements E F G éligibles septembre 2026",
  },
  {
    slug: "poele-a-bois-insert-chemine-aides-2026",
    title: "Poêle à bois et insert : les aides à saisir avant le 1er septembre 2026",
    excerpt: "MaPrimeRénov' pour les poêles à bois et inserts de cheminée s'arrête le 1er septembre. Montants par revenus, label Flamme Verte, prime CEE et démarches urgentes.",
    tag: "Chauffage",
    date: "25 août 2026",
    image: "/blog/poele-a-bois-insert-chemine-aides-2026.jpg",
    alt: "Poêle à bois et insert de cheminée : aides 2026",
  },
  {
    slug: "maprimeadapt-2026-aide-adaptation-logement-seniors",
    title: "MaPrimeAdapt' 2026 : jusqu'à 70 % des travaux pour adapter votre logement",
    excerpt: "Seniors et personnes handicapées peuvent obtenir jusqu'à 15 400 € pour douche adaptée, monte-escalier, élargissement de portes… Conditions, montants et démarches.",
    tag: "Aides",
    date: "24 août 2026",
    image: "/blog/maprimeadapt-2026-aide-adaptation-logement-seniors.jpg",
    alt: "MaPrimeAdapt' 2026 : adapter son logement au vieillissement ou au handicap",
  },
  {
    slug: "chaudiere-granules-bois-aides-2026",
    title: "Chaudière à granulés 2026 : fin de MaPrimeRénov' par geste, quelles aides restent ?",
    excerpt: "Depuis le 1er janvier 2026, la chaudière biomasse n'est plus éligible au parcours monogeste. CEE, TVA 5,5 %, Éco-PTZ et rénovation d'ampleur : toutes les alternatives pour financer votre projet.",
    tag: "Chauffage",
    date: "23 août 2026",
    image: "/blog/chaudiere-granules-bois-aides-2026.jpg",
    alt: "Chaudière à granulés de bois : aides disponibles en 2026",
  },
  {
    slug: "maprimerenov-ampleur-fin-gaz-septembre-2026",
    title: "MaPrimeRénov' rénovation d'ampleur : fin du chauffage au gaz dès le 1er septembre 2026",
    excerpt: "À partir du 1er septembre, une maison individuelle ne peut plus bénéficier de la rénovation d'ampleur si elle conserve un chauffage gaz. Ce qui change, les alternatives et comment anticiper.",
    tag: "MaPrimeRénov'",
    date: "22 août 2026",
    image: "/blog/maprimerenov-ampleur-fin-gaz-septembre-2026.jpg",
    alt: "MaPrimeRénov' rénovation d'ampleur : fin du gaz au 1er septembre 2026",
  },
  {
    slug: "france-renov-compte-unique-aides-anah-2026",
    title: "Nouveau compte FranceRénov' : toutes les aides Anah en un seul endroit depuis août 2026",
    excerpt: "MaPrimeRénov', MaPrimeAdapt', Loc'Avantages… Depuis le 17 août, un compte unique sécurisé par FranceConnect+ centralise toutes les démarches. Ce qui change pour votre dossier.",
    tag: "Aides",
    date: "21 août 2026",
    image: "/blog/france-renov-compte-unique-aides-anah-2026.jpg",
    alt: "Nouveau compte FranceRénov' — toutes les aides Anah centralisées",
  },
  {
    slug: "isolation-thermique-interieure-iti-2026",
    title: "Isolation par l'intérieur (ITI) 2026 : prix, aides CEE et quand la choisir",
    excerpt: "Appartement, secteur protégé ou budget serré ? L'ITI reste finançable via les CEE, la TVA à 5,5 % et l'éco-PTZ. Toutes les règles 2026 décryptées.",
    tag: "Isolation",
    date: "20 août 2026",
    image: "/blog/isolation-thermique-interieure-iti-2026.jpg",
    alt: "Isolation thermique par l'intérieur (ITI) en 2026",
  },
  {
    slug: "cumul-aides-renovation-maprimerenov-cee-eco-ptz",
    title: "Cumuler MaPrimeRénov', CEE et Éco-PTZ en 2026 : jusqu'à 90 % de vos travaux financés",
    excerpt: "Règles de cumul, plafonds selon les revenus et ordre des démarches pour combiner les trois grandes aides de la rénovation énergétique sans perdre une prime.",
    tag: "Financement",
    date: "19 août 2026",
    image: "/blog/cumul-aides-renovation-maprimerenov-cee-eco-ptz.jpg",
    alt: "Cumuler MaPrimeRénov', CEE et Éco-PTZ en 2026",
  },
  {
    slug: "isolation-plancher-bas-vide-sanitaire-2026",
    title: "Isolation plancher bas 2026 : aides MaPrimeRénov' et CEE encore disponibles",
    excerpt: "Vide sanitaire, sous-sol non chauffé : ce geste reste éligible au parcours par geste MaPrimeRénov' et aux CEE 6e période. Prix, montants et démarches.",
    tag: "Isolation",
    date: "18 août 2026",
    image: "/blog/isolation-plancher-bas-vide-sanitaire-2026.jpg",
    alt: "Isolation du plancher bas — vide sanitaire et aides 2026",
  },
  {
    slug: "maprimerenov-coproprietes-2026",
    title: "MaPrimeRénov' Copropriétés 2026 : jusqu'à 25 000 € par logement",
    excerpt: "30 à 45 % de vos travaux collectifs financés par l'ANAH, plus bonus copropriété fragile et cumul CEE. Conditions, barèmes et nouveauté 2026.",
    tag: "Copropriétés",
    date: "17 août 2026",
    image: "/blog/maprimerenov-coproprietes-2026.jpg",
    alt: "Immeuble en copropriété — rénovation énergétique collective 2026",
  },
  {
    slug: "nouveau-calcul-dpe-2026-reclassement",
    title: "Nouveau calcul DPE 2026 : 850 000 logements changent de classe sans travaux",
    excerpt: "Le coefficient électricité passe de 2,3 à 1,9 depuis janvier 2026 : découvrez si votre logement a gagné une classe énergétique et comment obtenir l'attestation actualisée sans nouvelle visite.",
    tag: "DPE",
    date: "16 août 2026",
    image: "/blog/nouveau-calcul-dpe-2026-reclassement.jpg",
    alt: "Étiquette DPE — nouveau coefficient électricité 2026",
  },
  {
    slug: "fenetres-remplacement-aides-2026",
    title: "Remplacement des fenêtres en 2026 : toutes les aides disponibles",
    excerpt: "MaPrimeRénov', CEE, TVA à 5,5 %, Éco-PTZ : comment financer le remplacement de vos fenêtres simple vitrage et réduire vos déperditions thermiques.",
    tag: "Menuiseries",
    date: "15 août 2026",
    image: "/blog/fenetres-remplacement-aides-2026.jpg",
    alt: "Remplacement de fenêtres double vitrage — aides 2026",
  },
  {
    slug: "panneaux-solaires-photovoltaiques-aides-2026",
    title: "Panneaux solaires 2026 : quelles aides après la fin de la prime à l'autoconsommation ?",
    excerpt: "La prime à l'autoconsommation a été supprimée le 5 juin 2026. TVA à 5,5 %, CEE, éco-PTZ : ce qui reste disponible et comment rentabiliser votre installation photovoltaïque malgré ce changement.",
    tag: "Énergie solaire",
    date: "14 août 2026",
    image: "/blog/panneaux-solaires-photovoltaiques-aides-2026.jpg",
    alt: "Maison avec panneaux solaires photovoltaïques — autoconsommation 2026",
  },
  {
    slug: "renovation-maison-ancienne-2026",
    title: "Rénover une maison ancienne en 2026 : guide pratique, pièges et aides",
    excerpt: "Isolation respirante, gestion de l'humidité, MaPrimeRénov'… Les maisons d'avant 1975 obéissent à des règles spécifiques. Découvrez les techniques adaptées au bâti ancien et les aides pour financer votre rénovation en 2026.",
    tag: "Bâti ancien",
    date: "13 août 2026",
    image: "/blog/renovation-maison-ancienne-2026.jpg",
    alt: "Maison ancienne en pierre — rénovation énergétique 2026",
  },
  {
    slug: "vmc-double-flux-aides-2026",
    title: "VMC double flux 2026 : prix, aides et la règle du geste couplé à connaître",
    excerpt: "Depuis janvier 2026, la VMC double flux n'est plus finançable seule par MaPrimeRénov'. Jusqu'à 2 500 € d'aide si couplée à l'isolation, plus CEE et TVA à 5,5 %. Prix, critères techniques et stratégie pour maximiser vos subventions.",
    tag: "Ventilation",
    date: "12 août 2026",
    image: "/blog/vmc-double-flux-aides-2026.jpg",
    alt: "Installation VMC double flux — ventilation mécanique contrôlée maison",
  },
  {
    slug: "isolation-murs-exterieure-ite-2026",
    title: "ITE 2026 : isolation des murs par l'extérieur — prix, aides et démarches",
    excerpt: "Traiter jusqu'à 25 % des déperditions sans perdre de surface habitable. En 2026, MaPrimeRénov' ITE passe uniquement par le Parcours accompagné. Coûts, CEE, éco-PTZ et étapes clés du chantier expliqués.",
    tag: "Isolation",
    date: "11 août 2026",
    image: "/blog/isolation-murs-exterieure-ite-2026.jpg",
    alt: "Isolation thermique par l'extérieur — chantier ITE sur maison individuelle",
  },
  {
    slug: "sortir-du-fioul-2026-alternatives-aides",
    title: "Sortir du fioul en 2026 : alternatives, aides et démarches pour changer de chauffage",
    excerpt: "Chaudière fioul interdite depuis 2022, jusqu'à 9 000 € d'aides cumulables (MaPrimeRénov' + CEE Coup de pouce + éco-PTZ). PAC air/eau, granulés, hybride : toutes les alternatives et les étapes pour agir.",
    tag: "Chauffage",
    date: "10 août 2026",
    image: "/blog/sortir-du-fioul-2026-alternatives-aides.jpg",
    alt: "Remplacement chaudière fioul — transition chauffage propre",
  },
  {
    slug: "isolation-combles-perdus-2026",
    title: "Isolation des combles perdus : agissez avant septembre pour cumuler MaPrimeRénov' et CEE",
    excerpt: "MaPrimeRénov' monogeste pour les combles disparaît le 1er septembre 2026. Jusqu'à 75 €/m² d'aides pour les ménages modestes, CEE cumulables, TVA à 5,5 % : tout ce qu'il faut savoir avant la date limite.",
    tag: "Urgence",
    date: "9 août 2026",
    image: "/blog/isolation-combles-perdus-2026.jpg",
    alt: "Isolation des combles perdus — laine soufflée dans des combles",
  },
  {
    slug: "ordre-travaux-renovation-energetique-2026",
    title: "Dans quel ordre faire ses travaux de rénovation énergétique en 2026 ?",
    excerpt: "Isoler d'abord, changer le chauffage ensuite : suivez la bonne séquence de travaux pour maximiser vos aides MaPrimeRénov', éviter les reprises et atteindre le saut de classes DPE qui débloque les financements les plus élevés.",
    tag: "Guide pratique",
    date: "8 août 2026",
    image: "/blog/ordre-travaux-renovation-energetique-2026.jpg",
    alt: "Dans quel ordre faire ses travaux de rénovation énergétique en 2026",
  },
  {
    slug: "chauffe-eau-thermodynamique-aides-2026",
    title: "Chauffe-eau thermodynamique 2026 : prix, aides et économies",
    excerpt: "Le CET consomme 3 fois moins qu'un chauffe-eau classique. Découvrez les aides cumulables en 2026 (MaPrimeRénov', CEE, TVA 5,5 %, Éco-PTZ) et comment choisir le bon modèle pour votre logement.",
    tag: "Équipement & économies",
    date: "7 août 2026",
    image: "/blog/chauffe-eau-thermodynamique-aides-2026.jpg",
    alt: "Chauffe-eau thermodynamique 2026 — aides et économies",
  },
  {
    slug: "tva-5-5-renovation-energetique-2026",
    title: "TVA à 5,5 % rénovation 2026 : travaux éligibles et démarches simplifiées",
    excerpt: "Sans condition de ressources, la TVA à 5,5 % s'applique à tous vos travaux de rénovation énergétique. Depuis la suppression du Cerfa, une simple mention sur le devis suffit — voici comment en profiter et combien vous économisez.",
    tag: "Aides & financement",
    date: "6 août 2026",
    image: "/blog/tva-5-5-renovation-energetique-2026.jpg",
    alt: "TVA 5,5 % rénovation énergétique 2026",
  },
  {
    slug: "aides-regionales-renovation-energetique-2026",
    title: "Aides régionales rénovation 2026 : les primes méconnues à cumuler avec MaPrimeRénov'",
    excerpt: "Hauts-de-France, Nouvelle-Aquitaine, PACA, Grand Est… votre région propose peut-être des subventions supplémentaires qui s'ajoutent aux aides nationales. Guide complet du cumul pour 2026.",
    tag: "Aides & financement",
    date: "5 août 2026",
    image: "/blog/aides-regionales-renovation-energetique-2026.jpg",
    alt: "Aides régionales rénovation énergétique 2026",
  },
  {
    slug: "renovation-ampleur-2026-accompagnateur-renov",
    title: "Rénovation d'ampleur 2026 : jusqu'à 80 % de vos travaux financés",
    excerpt: "Saut de 2 classes DPE, Accompagnateur Rénov' obligatoire, taux d'aide de 80 à 10 % selon vos revenus : tout ce qu'il faut savoir avant de lancer votre projet de rénovation globale.",
    tag: "Aides & financement",
    date: "4 août 2026",
    image: "/blog/renovation-ampleur-2026-accompagnateur-renov.jpg",
    alt: "Rénovation d'ampleur 2026 — jusqu'à 80 % de travaux financés",
  },
  {
    slug: "audit-energetique-obligatoire-vente-2026",
    title: "Audit énergétique obligatoire à la vente : ce que vous devez savoir en 2026",
    excerpt: "Classes E, F et G : l'audit réglementaire est obligatoire avant de vendre votre maison. Qui est concerné, quel prix, et comment en faire un levier d'aides.",
    tag: "Réglementation",
    date: "3 août 2026",
    image: "/blog/audit-energetique-obligatoire-vente-2026.jpg",
    alt: "Audit énergétique obligatoire à la vente en 2026",
  },
  {
    slug: "maprimerenov-septembre-2026-gestes-suppression",
    title: "MaPrimeRénov' : ce qui disparaît au 1er septembre 2026",
    excerpt: "Combles, fenêtres, VMC, chauffe-eau thermodynamique : cinq gestes quittent le parcours monogeste le 1er septembre. Ce qu'il faut faire avant la date limite.",
    tag: "Aides & financement",
    date: "2 août 2026",
    image: "/blog/maprimerenov-septembre-2026-gestes-suppression.jpg",
    alt: "MaPrimeRénov' — ce qui disparaît au 1er septembre 2026",
  },
  {
    slug: "eco-ptz-2026-pret-taux-zero-renovation",
    title: "Éco-PTZ 2026 : financer sa rénovation sans payer d'intérêts",
    excerpt: "Jusqu'à 50 000 € sans intérêts, sans conditions de revenus : l'éco-prêt à taux zéro est le complément idéal de MaPrimeRénov'. Montants, conditions, démarches et exemple chiffré.",
    tag: "Aides & financement",
    date: "1er août 2026",
    image: "/blog/eco-ptz-2026-pret-taux-zero-renovation.jpg",
    alt: "Éco-PTZ 2026 — prêt à taux zéro rénovation",
  },
  {
    slug: "cee-2026-prime-energie-comment-en-profiter",
    title: "Prime CEE 2026 : comment profiter des Certificats d'Économie d'Énergie",
    excerpt: "6ème période en vigueur, nouvelle doctrine juillet 2026 : tout ce qu'il faut savoir pour obtenir votre prime énergie sans conditions de revenus et la cumuler avec MaPrimeRénov'.",
    tag: "Aides & financement",
    date: "31 juil. 2026",
    image: "/blog/cee-2026-prime-energie-comment-en-profiter.jpg",
    alt: "Prime CEE 2026 — certificats d'économie d'énergie",
  },
  {
    slug: "dpe-2026-passoires-thermiques-location",
    title: "DPE 2026 : 850 000 logements reclasssés et nouvelles règles de location",
    excerpt: "Coefficient électricité abaissé, projet de loi Lecornu sur les passoires F et G, audit obligatoire à la vente : tout ce qui change pour les propriétaires en 2026.",
    tag: "DPE & réglementation",
    date: "30 juil. 2026",
    image: "/blog/dpe-2026-passoires-thermiques-location.jpg",
    alt: "DPE 2026 — passoires thermiques et location",
  },
  {
    slug: "canicule-aides-climatisation-2026",
    title: "Canicule 2026 : quelles aides pour climatiser son logement ?",
    excerpt: "La clim de confort n'est pas subventionnée : on fait le point sur les CEE, la TVA réduite, la PAC réversible et les vraies solutions pour un logement frais.",
    tag: "Confort d'été & aides",
    date: "30 juin 2026",
    image: "/blog/canicule-aides-climatisation-2026.jpg",
    alt: "Climatisation et confort d'été",
  },
  {
    slug: "pompe-a-chaleur-air-eau-prix-aides-2026",
    title: "Pompe à chaleur air/eau en 2026 : prix, aides et rentabilité",
    excerpt: "Combien coûte une PAC air/eau en 2026 ? Prix, MaPrimeRénov', CEE, TVA à 5,5 % et reste à charge : le point pour calculer la rentabilité de votre projet.",
    tag: "Chauffage & aides",
    date: "30 juin 2026",
    image: "/blog/pompe-a-chaleur-air-eau-prix-aides-2026.jpg",
    alt: "Pompe à chaleur air/eau devant une maison",
  },
  {
    slug: "valorisation-immobiliere-renovation-energetique",
    title: "Valoriser son patrimoine immobilier en 2026 : la rénovation énergétique comme levier",
    excerpt: "En 2026, la performance énergétique n'est plus un détail : c'est l'un des principaux critères de valeur d'un logement. Tour d'horizon des leviers pour valoriser un bien.",
    tag: "Conseils patrimoine",
    date: "18 juin 2026",
    image: "/DALL-E-2-maison.webp",
    alt: "Maison rénovée et valorisée",
  },
];

/** Vignette optimisée, générée au build dans public/blog/thumbs/ (voir scripts/make-blog-thumbs.mjs). */
export const articleThumb = (article) => `/blog/thumbs/${article.slug}.webp`;

/** URL de la page article. */
export const articlePath = (article) => `/blog/${article.slug}`;
